export default __webpack_public_path__ + "static/media/2023-03-02T06_06_08.844Z_2_5.05841af3.jpeg";